var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"type":"grow","variant":"secondary"}}),_c('br')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }